import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VoicesComponent } from './voices.component';

const routes: Routes = [
  {
    path: '',
    component: VoicesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VoicesRoutingModule {}
